var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('v-footer',{attrs:{"padless":"","color":"rgb(0, 0, 0, 0.4)","dark":true}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" D.R. © Solena Ag, Inc. "),_c('strong',[_vm._v("Av. Olímpica 3020-D Villas de San Juan 37295, León Gto, México. 2021")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }